import {Injectable} from '@angular/core';
import {ExamenDefinitionModel} from "../../../api/entity/examenDefinition.model";
import {
    AbstractDataServiceDtoAdapter
} from "../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";
import {ExamenDefinitionConverter} from "../../../api/entity/converter/examenDefinition.converter";
import {ExamenDefinitionDataService} from "./examenDefinitionData.service";

@Injectable()
export class ExamenDefinitionDataServiceAdapter extends AbstractDataServiceDtoAdapter<ExamenDefinitionModel, ExamenDefinitionConverter> {
    constructor(dataService: ExamenDefinitionDataService, converter: ExamenDefinitionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ExamenDefinitionModel {
        return new ExamenDefinitionModel();
    }


}
